export const FETCH_INVENTORY_UPDATES = 'FETCH_INVENTORY_UPDATES';
export const INVENTORY_UPDATE_SET_PAGE_SIZE = 'INVENTORY_UPDATE_SET_PAGE_SIZE';
export const INVENTORY_UPDATE_SET_PAGE_NO = 'INVENTORY_UPDATE_SET_PAGE_NO';
export const CLEAR_INVENTORY_UPDATE = 'CLEAR_INVENTORY_UPDATE';
